/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Created_ToastInputs */



/**
* | output |
* | --- |
* | "New style guide created" |
*
* @param {Style_Guide_Manager_Created_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_created_toast = /** @type {((inputs?: Style_Guide_Manager_Created_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Created_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau guide de style cree")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Styleguide erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuova guida di stile creata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создан новый стиль оформления.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se creó una nueva guía de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新版风格指南已制定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいスタイルガイドが作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई स्टाइल गाइड बनाई गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo guia de estilo criado")
	return /** @type {LocalizedString} */ ("New style guide created")
});